(function () {
    'use strict';
    var controllerId = 'cndPCatalogoCorsoAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'pCatalogoCorso', 'partecipazioneId', 'aplId', 'tMisuraCode', 'province', 'tIndirizzi', 'tFigProfessionali', 'tPercorsi', fn_cndPCatalogoCorsoAdd]);

    function fn_cndPCatalogoCorsoAdd($scope, datacontext, $uibModalInstance, pCatalogoCorso, partecipazioneId, aplId, tMisuraCode, province, tIndirizzi, tFigProfessionali, tPercorsi) {
        $scope.province = province;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi;  

        $scope.tFigProfessionali = tFigProfessionali;
        $scope.tPercorsi = tPercorsi;

        if (pCatalogoCorso) {
            $scope.title = 'Modifica';
            $scope.record = jQuery.extend({}, pCatalogoCorso); //Clona oggetto
            if ($scope.record.SedeSvolg_ProvinciaId > 0) {
                getComuni($scope.record.SedeSvolg_ProvinciaId);
            }
        }
        else {
            $scope.title = 'Nuovo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.SedeSvolg_TIndirizzoId = 1;
            $scope.record.SedeSvolg_ComuneId = '';
            
        }

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.PartecipazioneId = partecipazioneId;
        }
        if (aplId) {
            $scope.aplId = aplId;
            $scope.record.APLId = aplId;
        }
        if (tMisuraCode) {
            $scope.tMisuraCode = tMisuraCode;
            $scope.record.TMisuraCode = tMisuraCode;
            if (tMisuraCode == '4A') {
                $scope.record.M4A_bGruppo = true;
            }
        }

        $scope.change_bGruppo = function () {
            if ($scope.record.M4A_bGruppo) {
                $scope.record.TFigProfessionaleId = 0;
                $scope.record.M4A_SedeSvolgAllieviMax = 0;
                $scope.record.M4A_DecretoNum = '';
                $scope.record.M4A_DecretoDt = '';
            }
            else {
                $scope.record.M4A_Classe = 0;
                $scope.record.AllieviMax = 0;
            }
        };


        $scope.warningAllievi = false;
        $scope.change_mis2B = function () {            
            var maxStd = 27;
            var minStd = 18;

            $scope.warningAllievi = false;
            if ($scope.record.NumClasse > 0) {
                if ($scope.record.AllieviMax > 0) {
                    var maxAllievi_prev = maxStd * $scope.record.NumClasse;
                    var minAllievi_prev = minStd * $scope.record.NumClasse;
                    if ($scope.record.AllieviMax < minAllievi_prev || $scope.record.AllieviMax > maxAllievi_prev) {
                        $scope.warningAllievi = true;
                    }
                }
            }            
        };

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                $scope.record.M4A_DecretoDt = '';
                $scope.changed = true;
            }
        };

        $scope.format = "dd/MM/yyyy";

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {

                    if ($scope.tMisuraCode == '4A' && !$scope.record.M4A_bGruppo) {
                        $scope.record.AllieviMax = 1;
                    }

                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result1 = updateItem($scope.record);
                    $uibModalInstance.close(result1);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.pCatalogoCorso_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.pCatalogoCorso_merge(item).then(function (data) {
                return data;
            });
        }

        $scope.change_Comuni = function (idprov) {
            $scope.record.SedeSvolg_ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.SedeSvolg_ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }

    }
})();